// test1879
(1879 && 0);
